import React from 'react';
import { OTPInput } from '../components/Auth-Designer/OTPInput';

const OTPPage = () => {
  return (
    <main>
      <OTPInput />
    </main>
  );
};

export default OTPPage;